import { handleActions } from 'redux-actions'
import {
  setModifierKeyState,
  TriState,
  hardwareKeyDown,
  mouseDown,
  mouseWheel,
  switchFitToScreen,
  notifyMonitors,
  tbShowModal,
  tbHideModal,
  tbCloseModal,
} from '../actions/toolbar'
import { changeMonitor } from '../actions/webrtcConnection'

const initialState = {
  expanded: true,
  fitToScreen: true,
  modifiers: {
    Control: TriState.Inactive,
    Alt: TriState.Inactive,
    Shift: TriState.Inactive,
    Meta: TriState.Inactive
  },
  monitors: [],
  activeMonitorId: '',
  modal: {}
}

export const toolbarReducer = handleActions({
  [setModifierKeyState] (prevState, action) {
    const { key, state } = action.payload
    switch (key) {
      case 'Control':
        return {
          ...prevState,
          modifiers: { ...prevState.modifiers, Control: state }
        }
      case 'Alt':
        return {
          ...prevState,
          modifiers: { ...prevState.modifiers, Alt: state }
        }
      case 'Shift':
        return {
          ...prevState,
          modifiers: { ...prevState.modifiers, Shift: state }
        }
      case 'Meta':
        return {
          ...prevState,
          modifiers: { ...prevState.modifiers, Meta: state }
        }
      default:
        break
    }
  },
  [hardwareKeyDown] (prevState) {
    return {
      ...prevState
    }
  },
  [mouseDown] (prevState) {
    return {
      ...prevState
    }
  },
  [mouseWheel] (prevState) {
    return {
      ...prevState
    }
  },
  [notifyMonitors] (prevState, action) {
    return {
      ...prevState,
      monitors: action.payload,
    }
  },
  [changeMonitor] (prevState, action) {
    return {
      ...prevState,
      activeMonitorId: action.payload
    }
  },
  [switchFitToScreen] (prevState, action) {
    return {
      ...prevState,
      fitToScreen: action.payload,
    }
  },
  [tbShowModal] (prevState, { payload: modalId }) {
    return {
      ...prevState,
      modal: { ...prevState.modal, [modalId]: 'open' },
    }
  },
  [tbHideModal] (prevState, { payload: modalId }) {
    return {
      ...prevState,
      modal: { ...prevState.modal, [modalId]: 'hidden' },
    }
  },
  [tbCloseModal] (prevState, { payload: modalId }) {
    const modal = { ...prevState.modal }
    Reflect.deleteProperty(modal, modalId)
    return {
      ...prevState,
      modal,
    }
  },
}, initialState)
